export default {
    currentUser: state => state.user.currentUser,
    authStatus: state => state.user.authStatus,
    token: state => state.user.token,
    isLoggIn: state => state.user.isLoggIn
}
